export const QUERY_KEY = 'NARRATIVE' as const;
export const getQueryKey = (id: string): [string, string] => [QUERY_KEY, id];
